export const state = () => ({
    tags: []
})

export const getters = {
    TAGS: state => state.tags
}

export const actions = {
    async GET(vuexContext) {
        try {
            const tags = await this.$axios.$get('dealer-orders-tags')

            if (Array.isArray(tags)) {
                vuexContext.commit('SET', tags)
                return Promise.resolve()
            } else {
                return Promise.reject('Cart getting server error')
            }
        } catch (err) {
            return Promise.reject('Cart getting server error')
        }
    },

    ADD(vuexContext, tag) {
        vuexContext.commit('ADD', tag)
    },

    DELETE(vuexContext, value) {
        vuexContext.commit('DELETE', value)
    },

    CHANGE(vuexContext, { value, tag }) {
        vuexContext.commit('CHANGE', { value, tag })
    },
}

export const mutations = {
    SET(state, tags) {
        state.tags = tags
    },

    ADD(state, tag) {
        state.tags.push(tag)
    },

    DELETE(state, value) {
        state.tags = state.tags.filter(tag => tag.value !== value)
    },

    CHANGE(state, { value, tag }) {
        const currentTag = state.tags.find(tag => tag.value === value)

        if (currentTag) {
            currentTag.value = tag.value
            currentTag.name = tag.name
            currentTag.color = tag.color
        }
    },
}